import React, { useEffect, useRef, useState } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import filter from "../../../assets/images/filter.svg";
import BlueFilterIcon from "../../../assets/images/BlueFilterIcon.svg";
import { MultiSelect } from "primereact/multiselect";

const ChangeHandlingFilter = ({
  op,
  onSort,
  selectedColumnName,
  setSelectedColumnName,
  tableData,
  selectedFields,
  onGlobalFilterChange,
  setFieldUpdated,
  fieldUpdated,
  clearColumnWiseFilter,
  sortData
}) => {
  const [columnWiseSelectedFields, setColumnWiseSelectedFields] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const acpFilterRef = useRef();
  let isACPFilterClicked = useRef(false);

  useEffect(() => {
    const handleClick = (event) => {
      if (acpFilterRef?.current) {
        isACPFilterClicked.current = acpFilterRef?.current?.contains(event.target);
      }
    };

    document.addEventListener("click", handleClick, true);

    return () => document.removeEventListener("click", handleClick, true);
  }, [acpFilterRef]);

  // Get unique options for the current column
  const optionList = Array.from(new Set(tableData.map(row => row.data?.[selectedColumnName]).filter(v => v !== undefined && v !== null && v !== "")));

  useEffect(() => {
    if (selectedFields && selectedColumnName) {
      const val = selectedFields[selectedColumnName];
      setColumnWiseSelectedFields(Array.isArray(val) ? val : val ? [val] : []);
    }
  }, [selectedFields, selectedColumnName]);

  // Filter options by search value
  const filteredOptions = optionList.filter(opt =>
    opt?.toString().toLowerCase().includes(searchValue.toLowerCase())
  );

  // MultiSelect expects options as array of objects with label/value, not primitives
  const multiSelectOptions = filteredOptions.map(opt => ({ label: String(opt), value: opt }));

  // Defensive: always ensure MultiSelect value is a flat array of primitives
  const getSafeArray = val => {
    if (Array.isArray(val)) {
      return val.flat(Infinity).filter(v => v !== undefined && v !== null && (typeof v !== 'object' && typeof v !== 'function'));
    }
    if (val === undefined || val === null) return [];
    return [val];
  };
  const safeColumnWiseSelectedFields = getSafeArray(columnWiseSelectedFields).filter(v =>
    multiSelectOptions.some(opt => opt.value === v || opt.value?.toString() === v?.toString())
  );
  const safeMultiSelectOptions = Array.isArray(multiSelectOptions) ? multiSelectOptions : [];

  // --- UI/UX parity with Artwork Alignment ---
  // Add Freeze button, use same classNames, structure, and icon logic
  // (Assume freeze is not functional in ChangeHandling, but button is present for parity)
  
  const handleMultiselectOptionClose = () => {
    if(!isACPFilterClicked.current) {
      setSelectedColumnName && setSelectedColumnName(null);
      op?.current?.hide();
    }
  }
  
  return (
    <span>
      <OverlayPanel className="overlay" ref={op}>
        <div className="acp-filters" ref={acpFilterRef}>
          {/* Removed the close (X) icon at the top for parity with Artwork Alignment */}
          <div className="clearAllFilterMainDiv">
            <div
              id="clearAllFilter"
              className="clearAllFilter"
              onClick={() => {
                clearColumnWiseFilter();
                setFieldUpdated && setFieldUpdated(!fieldUpdated);
              }}
            >
              Clear Column filter
            </div>
            <div className="clearAllFilterDiv" >
              <img
                src={filter}
                alt="filter logo"
                onClick={() => clearColumnWiseFilter()}
                className="header-icons"
              />
            </div>
          </div>
          <div
            id="sortZtoA"
            className="sortAndFrozen"
            onClick={() => onSort(selectedColumnName, "desc")}
          >
            {sortData?.[0] === selectedColumnName && sortData?.[1] === "desc" ? (
              <div className="sort-label">Sort z to a</div>
            ) : (
              <div>Sort z to a</div>
            )}
          </div>
          <div
            id="sortAtoZ"
            className="sortAndFrozen"
            onClick={() => onSort(selectedColumnName, "asc")}
          >
            {sortData?.[0] === selectedColumnName && sortData?.[1] === "asc" ? (
              <div className="sort-label">Sort a to z</div>
            ) : (
              <div>Sort a to z</div>
            )}
          </div>
          <div className="multiSelect">
            <MultiSelect
              value={safeColumnWiseSelectedFields}
              onChange={e => {
                let val = getSafeArray(e.value).filter(v =>
                  safeMultiSelectOptions.some(opt => opt.value === v || opt.value?.toString() === v?.toString())
                );
                setColumnWiseSelectedFields(val);
                onGlobalFilterChange(val, selectedColumnName);
              }}
              options={safeMultiSelectOptions}
              optionLabel="label"
              optionValue="value"
              filter={true}
              filterTemplate={(options) => (
                <div className="filter-container" >
                  {options && options.element}
                </div>
              )}
              placeholder={`Select ${selectedColumnName}`}
              maxSelectedLabels={3}
              className="p-column-filter"
              style={{ width: "100%" }}
              panelClassName="dsbpScreen-multiselect-dropdown"
              itemTemplate={option => <div>{option.label}</div>}
              onHide={() => handleMultiselectOptionClose()}
            />
          </div>
        </div>
      </OverlayPanel>
    </span>
  );
};

export default ChangeHandlingFilter;
